import styled from 'styled-components';
import { AdornedInputMixin } from '../../mixins/components/AdornedInputMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledAdornedInput = /*#__PURE__*/styled('div').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['disabled', 'readOnly'])
}).withConfig({
  displayName: "StyledAdornedInput",
  componentId: "c11n-8-111-1__sc-tbqtlr-0"
})(["", ""], AdornedInputMixin);